import { ACTION_EXTERNAL_DATA } from './actions'
import externalDataApi from '@/api/externalData'
import {
  IExternalDataColumn,
  IExternalDataMember,
  IExternalDataMembersResponse,
  IExternalDataListResponse,
  IExternalDataMembersParams,
  IExternalDataListParams,
} from '@/utils/types'
import cloneDeep from 'lodash/cloneDeep'
import { localStore } from '@/utils/localstore'
import { constant } from '@/utils/constants'

type ExternalDataState = {
  columns: IExternalDataColumn[]
  members: IExternalDataMembersResponse
  loading: boolean
}

export default {
  state: {
    columns: [],
    members: {
      items: [],
      total: 0,
      page: 1,
      per_page: 100,
      total_pages: 0,
    },
    loading: false,
  },
  getters: {
    columns: (state: ExternalDataState) => {
      return state.columns as IExternalDataColumn[]
    },
    members: (state: ExternalDataState) => {
      return state.members as IExternalDataMembersResponse
    },
  },
  mutations: {
    [ACTION_EXTERNAL_DATA.SET_ITEMS]: (state: ExternalDataState, { columns }: { columns: IExternalDataColumn[] }) => {
      state.columns = cloneDeep(columns)
    },
    [ACTION_EXTERNAL_DATA.SET_MEMBERS]: (state: ExternalDataState, { members }: { members: IExternalDataMembersResponse }) => {
      state.members = cloneDeep(members)
    },
  },
  actions: {
    [ACTION_EXTERNAL_DATA.LOAD_COLUMNS]: async ({ commit }, app_id: string) => {
      const key = constant.LOCAL_KEYS.ASSETS_EXTERNAL_DATA_COLUMNS + app_id
      let resp
      resp = localStore.getWithExpiry(key)
      if (!resp) {
        resp = await externalDataApi.getColumns(app_id)
        // localStore.setWithExpiry(key, resp, constant.LOCAL_EXPIRED)
      }
      const columns = Array.isArray(resp) ? resp : []
      commit(ACTION_EXTERNAL_DATA.SET_ITEMS, { columns })
      return columns
    },
    [ACTION_EXTERNAL_DATA.LOAD_MEMBERS]: async ({ commit }, params: IExternalDataMembersParams) => {
      const key = constant.LOCAL_KEYS.ASSETS_EXTERNAL_DATA_MEMBERS + params.app_id + JSON.stringify(params)
      let resp
      resp = localStore.getWithExpiry(key)
      if (!resp) {
        resp = await externalDataApi.getMembers(params)
        // localStore.setWithExpiry(key, resp, constant.LOCAL_EXPIRED)
      }
      const members: IExternalDataMembersResponse = resp || {
        items: [],
        total: 0,
        page: params.page || 1,
        per_page: params.per_page || 100,
        total_pages: 0,
      }
      commit(ACTION_EXTERNAL_DATA.SET_MEMBERS, { members })
      return members
    },
    [ACTION_EXTERNAL_DATA.LIST_FILES]: async ({ commit }, payload: IExternalDataListParams) => {
      const resp = await externalDataApi.listFiles(payload)
      return resp as IExternalDataListResponse
    },
  },
}
